import { render, staticRenderFns } from "./itemComponent.vue?vue&type=template&id=c40299aa&scoped=true&"
import script from "./itemComponent.vue?vue&type=script&lang=js&"
export * from "./itemComponent.vue?vue&type=script&lang=js&"
import style0 from "./itemComponent.vue?vue&type=style&index=0&id=c40299aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40299aa",
  null
  
)

export default component.exports